function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .heart_svg__heart_svg__st0{fill:none;stroke:#717375;stroke-width:0.5365}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "heart_svg__heart_svg__st0",
  d: "M14.7,2.4C13.3,1,11,1,9.6,2.4L8.5,3.5L7.4,2.4C6,1,3.7,1,2.3,2.4s-1.4,3.7,0,5.1l6.2,6.2l6.2-6.2 C16.1,6.1,16.1,3.8,14.7,2.4z"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 15",
    style: {
      enableBackground: "new 0 0 17 15"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgHeart;